import React, { Component, createRef, useContext, useEffect, useState } from 'react';
import {motion} from "framer-motion";
import axios from 'axios';
import {AppContext} from "../../context/app/appContext";
import {useHistory} from "react-router-dom";
import {Dimmer, Loader} from "semantic-ui-react";
import * as Msal from "msal";
import * as msal from "@azure/msal-browser";

const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

export const LoginMicrosoftRedirect = (props) => {
    const history = useHistory();
    const appContext = useContext(AppContext);

    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [feedbackMessageClass, setFeedbackMessageClass] = useState('error');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('');

    // const msalConfig = {
    //     auth: {
    //         clientId: '57039aba-6021-4813-9764-984a5b29277a',
    //         postLogoutRedirectUri: 'http://localhost:3000'
    //     }
    // };
    // const msalInstance = new Msal.UserAgentApplication(msalConfig);
    const myMsal = new msal.PublicClientApplication({
        auth: {
            clientId: '57039aba-6021-4813-9764-984a5b29277a',
            redirectUri: "http://localhost:3000/login", //defaults to application start page
            postLogoutRedirectUri: "http://localhost:3000/login",
            navigateToLoginRequestUrl: false
        }
    })

    console.log(myMsal)

    // msalInstance.handleRedirectCallback((error, response) => {
    //     // handle redirect response or error
    //     console.info({error})
    //     console.info({response})
    // });

    useEffect(() => {
        loginMicrosoft()
    }, [])

    const loginMicrosoft = () => {
        console.log(myMsal.getAllAccounts())
        
        // if(myMsal.getAllAccounts().length){
        //     console.log("hereeeeeeee")
        //     // console.log(myMsal.logout)
        //     myMsal.logout({
        //         account: myMsal.getAllAccounts()[0],
        //         // authority: "http://localhost:3000",
        //         redirectUri: 'http://localhost:3000/login',
        //         postLogoutRedirectUri: "http://localhost:3000/login",
        //         navigateToLoginRequestUrl: false
        //     })
        // }else{
            var loginRequest = {
                prompt: 'select_account',
                scopes: ["user.read"], // optional Array<string>
            };
         
             myMsal.loginPopup(loginRequest)
                 .then(response => {
                     // handle response
                     console.log("responseeeeeee")
                     console.info({response})
                 })
                 .catch(err => {
                     // handle error
                     console.log(err)
                 });
                 myMsal.getLogger()
        // }
        
    }

    const loader = (
        <Dimmer active>
            <Loader size="large">loading...</Loader>
        </Dimmer>
    )

    return (
        <div style={{height: '100%', width: '100%'}}>
            {loading ? loader: null}
        </div>
    )
}